import React from 'react';
import './VenmoCard.css';

const VenmoCard = ({ transaction, currentUser, onLike, onComment }) => {
  const isPayment = transaction.type === 'payment';
  const isSender = transaction.sender_id === currentUser?.id;
  const isReceiver = transaction.receiver_id === currentUser?.id;
  
  const getDisplayText = () => {
    if (isPayment) {
      if (isSender) {
        return `You paid ${transaction.receiver_name}`;
      } else if (isReceiver) {
        return `${transaction.sender_name} paid you`;
      } else {
        return `${transaction.sender_name} paid ${transaction.receiver_name}`;
      }
    } else {
      if (isSender) {
        return `You charged ${transaction.receiver_name}`;
      } else if (isReceiver) {
        return `${transaction.sender_name} charged you`;
      } else {
        return `${transaction.sender_name} charged ${transaction.receiver_name}`;
      }
    }
  };

  const getAmountDisplay = () => {
    if (isSender && isPayment) return `-$${transaction.amount}`;
    if (isReceiver && isPayment) return `+$${transaction.amount}`;
    if (transaction.type === 'charge') return `$${transaction.amount}`;
    return `$${transaction.amount}`;
  };

  const getAmountColor = () => {
    if (isSender && isPayment) return 'amount-negative';
    if (isReceiver && isPayment) return 'amount-positive';
    if (transaction.type === 'charge') return 'amount-charge';
    return 'amount-neutral';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days} days ago`;
    return date.toLocaleDateString();
  };

  const hasUserLiked = transaction.likes.likes.some(like => like.user_id === currentUser?.id);

  return (
    <div className="venmo-card">
      <div className="card-header">
        <div className="profile-section">
          <img 
            src={transaction.sender_picture || 'https://i.pravatar.cc/40?img=1'} 
            alt={transaction.sender_name}
            className="profile-picture"
          />
          <div className="transaction-info">
            <div className="transaction-text">{getDisplayText()}</div>
            <div className="transaction-note">{transaction.note}</div>
            <div className="transaction-date">{formatDate(transaction.created_at)}</div>
          </div>
        </div>
        <div className={`transaction-amount ${getAmountColor()}`}>
          {getAmountDisplay()}
        </div>
      </div>
      
      <div className="card-actions">
        <button 
          className={`action-button like-button ${hasUserLiked ? 'liked' : ''}`}
          onClick={() => onLike(transaction.id, currentUser?.id)}
        >
          <i className={`fas fa-heart ${hasUserLiked ? 'text-red' : ''}`}></i>
          {transaction.likes.likes.length > 0 && (
            <span className="action-count">{transaction.likes.likes.length}</span>
          )}
        </button>
        
        <button 
          className="action-button comment-button"
          onClick={() => onComment(transaction.id)}
        >
          <i className="fas fa-comment"></i>
          {transaction.comments.comments.length > 0 && (
            <span className="action-count">{transaction.comments.comments.length}</span>
          )}
        </button>
      </div>

      {transaction.comments.comments.length > 0 && (
        <div className="comments-section">
          {transaction.comments.comments.map(comment => (
            <div key={comment.id} className="comment">
              <strong>{comment.username}</strong>: {comment.text}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VenmoCard;